<template>
  <ul
    class="d-flex flex-column align-start justify-start pl-2 children"
  >
    <!-- This is a recursive component so we use TreeItem again for children -->
    <TreeItem
      v-for="childOption in option.children"
      :key="childOption[idKey]"
      :option="childOption"
      :selected="selected"
      is-child
      :id-key="idKey"
      :level-has-children="levelHasChildren"
      @update:model-value="$emit('update:modelValue', $event)"
    >
      <template #option-label="{ option: slotOption }">
        <slot
          name="option-label"
          :option="slotOption"
        />
      </template>
    </TreeItem>
  </ul>
</template>

<script setup>
import TreeItem from '@/components/shared/TreeItem.vue';

defineProps({
  option: {
    type: Object,
    default: () => ({}),
  },
  selected: {
    type: Array,
    default: () => ([]),
  },
  levelHasChildren: {
    type: Boolean,
    default: false,
  },
  idKey: {
    type: String,
    default: 'id',
  },
});

defineEmits(['update:modelValue']);
</script>
